import React, { useEffect, useState } from "react";
import "./ChildWebUsers.css";

export default function ChildWebUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterSite, setFilterSite] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10); // items per page

  // Fetch users
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await fetch("https://dashboard.dilammo.com/api/child/all");
      const data = await res.json();
      console.log(data[0]);
      if (res.ok) {
        setUsers(data || []);
      } else {
        throw new Error(data.message || "Failed to load users");
      }
    } catch (err) {
      console.error(err);
      setError("Unable to load tracked users.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Toggle user status
  const toggleStatus = async (id, currentStatus) => {
    try {
      const res = await fetch(
        `https://dashboard.dilammo.com/api/child/${id}/toggle-status`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            status: currentStatus === "active" ? "inactive" : "active",
          }),
        }
      );
      if (res.ok) fetchUsers();
    } catch (err) {
      console.error(err);
    }
  };

  // Filter + search
  const filteredUsers = users
    .filter(
      (u) =>
        u.name?.toLowerCase().includes(search.toLowerCase()) ||
        u.email?.toLowerCase().includes(search.toLowerCase()) ||
        u.ip_address.includes(search)
    )
    .filter((u) => (filterStatus ? u.status === filterStatus : true))
    .filter((u) => (filterSite ? u.site === filterSite : true));

  // Pagination
  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const currentUsers = filteredUsers.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredUsers.length / perPage);

  const handlePageChange = (page) => setCurrentPage(page);

  return (
    <div className="child-users-container">
      <h2>Tracked Users</h2>

      <div className="filters">
        <input
          type="text"
          placeholder="Search by name, email, IP..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
        >
          <option value="">All Status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
        <select
          value={filterSite}
          onChange={(e) => setFilterSite(e.target.value)}
        >
          <option value="">All Sites</option>
          <option value="gradient">Gradient</option>
          <option value="color">Color</option>
          <option value="main">Main</option>
        </select>
      </div>

      {loading && <p>Loading users...</p>}
      {error && <p className="error">{error}</p>}
      {!loading && currentUsers.length === 0 && <p>No users found.</p>}

      {!loading && currentUsers.length > 0 && (
        <>
          <table className="child-users-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>IP Address</th>
                <th>Site</th>
                <th>Visit Count</th>
                <th>Status</th>
                <th>Created At</th>
                <th>Updated At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers.map((u) => (
                <tr key={u.id}>
                  <td>{u.id}</td>
                  <td>{u.name || "N/A"}</td>
                  <td>{u.email || "N/A"}</td>
                  <td>{u.ip_address}</td>
                  <td>{u.site}</td>
                  <td>{u.visit_count}</td>
                  <td>
                    <span
                      className={`status-badge ${
                        u.status === "active" ? "active" : "inactive"
                      }`}
                    >
                      {u.status}
                    </span>
                  </td>
                  <td>{new Date(u.created_at).toLocaleString()}</td>
                  <td>{new Date(u.updated_at).toLocaleString()}</td>
                  <td>
                    <button
                      className="toggle-btn"
                      onClick={() => toggleStatus(u.id, u.status)}
                    >
                      {u.status === "active" ? "Deactivate" : "Activate"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="pagination">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
              <button
                key={num}
                className={num === currentPage ? "active-page" : ""}
                onClick={() => handlePageChange(num)}
              >
                {num}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
